var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-bar"},[_c('div',{staticClass:"route-bar-breadcrumb"},[_c('ul',[_c('li',[_c('button',{staticClass:"p-link",on:{"click":_vm.home}},[_c('i',{staticClass:"pi pi-home"})])]),_vm._l((_vm.$route.path.split('/')),function(path){return [(path)?_c('li',{key:path},[_vm._v("/ "+_vm._s(path))]):_vm._e()]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }